import React from "react"
import { Popover } from "react-bootstrap"
import "./MobileFriendlyWarning.css"

const mobileFriendlyWarning = (titleText: string, contentText?: string) => (
    <Popover id="dynamic-form-mobile-friendly-warning-popover">
        <Popover.Title id="dynamic-form-mobile-friendly-warning-popover-title">
            <div className="MobileFriendlyWarningPopoverTitle">
                <div className="MobileFriendlyWarningPopoverTitleLeft">
                    <div className="MobileFriendlyWarningPopoverTitleLeftSpans">
                        <div className="MobileFriendlyWarningPopoverTitleLeftSpan1">
                            <span className="material-icons">phone_iphone</span>
                        </div>
                        <div className="MobileFriendlyWarningPopoverTitleLeftSpan2">
                            <span className="material-icons-outlined">close</span>
                        </div>
                    </div>
                </div>
                <div className="MobileFriendlyWarningPopoverTitleRight">
                    <p>{titleText}</p>
                </div>
            </div>
        </Popover.Title>
        {contentText && <Popover.Content id="dynamic-form-mobile-friendly-warning-popover-content">
            <div className="MobileFriendlyWarningPopoverContent">
                <p>{contentText}</p>
            </div>
        </Popover.Content>}

    </Popover>
)


export default mobileFriendlyWarning